export const EVENT_START_TIME = new Date(Date.UTC(2025, 7, 8, 12, 0, 0)) // June is month 5 (0-indexed), 17:00 UTC is 10am PDT (Las Vegas time)
export const EVENT_NAME = "Rare Evo"
export const EVENT_DESCRIPTION = "Presented by Rebud, badbad & Apex Fusion"
export const SOCIAL_TAP_POINT_REWARD = 1

export const ENABLE_SHOP = true

export const CHANNELS = [
	{ name: "twitter", label: "Twitter" },
	{ name: "telegram", label: "Telegram" },
	{ name: "instagram", label: "Instagram" },
] as const

export function getSocialChannelUrl(
	handle: string,
	channelName: string,
): string {
	switch (channelName) {
		case "twitter":
			return `https://twitter.com/${handle}`
		case "telegram":
			return `https://t.me/${handle}`
		case "instagram":
			return `https://instagram.com/${handle}`
		default:
			console.warn(`missing social channel url config for: ${channelName}`)
			return ""
	}
}

export const ENABLE_FRIEND_CONNECTIONS = true

export const COLLECT_WALLETS = false

export const CONNECTION_TERMS = {
    connection: "friend",
    pendingConnection: "friend request",
	connectAction: {
		currentTense: "share",
		pastTense: "shared details"
	},
	connectedAt: "You became friends"
}

export const POINTS_NAME: "tickets" | "points" = "points"
